import React, { useEffect, useRef, useState } from 'react';

import useGlobalState from 'crm/GlobalStateContext';

export default function PageScrollerNavigation({ onButtonClick }: Readonly<{ onButtonClick?: Function }>) {
    const { pageScrollerList } = useGlobalState();

    if (pageScrollerList.length <= 1) {
        return null;
    }

    return (
        <>
            {pageScrollerList.map((item) => (
                <span key={item.element.id}>
                    <button
                        className="btn btn-light btn-sm px-2 py-1 mr-1 mb-1 rounded"
                        type="button"
                        onClick={(event) => {
                            event.currentTarget.blur();
                            item.element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
                            onButtonClick?.();
                        }}
                    >
                        {item.name}
                    </button>
                </span>
            ))}
        </>
    );
}

let anchorUniqueId = 1;

export function PageScrollerAnchor({ name, scrollMargin = 78 }: Readonly<{ name: string; scrollMargin?: number }>) {
    const { setPageScrollerList } = useGlobalState();
    const [id] = useState(() => `page-scroller-anchor-${anchorUniqueId++}`);
    const element = useRef<HTMLDivElement>();

    useEffect(() => {
        element.current.style.scrollMarginTop = `${scrollMargin}px`;
        setPageScrollerList((list) => [...list, { name, element: element.current }]);

        return () => setPageScrollerList((list) => list.filter((item) => item.element.id !== id));
    }, []);

    return <div id={id} ref={element} />;
}
